export default "__VITE_ASSET__CGlEKLfy__"